import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import axios from 'axios';
import './PaymentResult.css';

function PaymentResult() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const statusParam = searchParams.get('status');
        const refId = searchParams.get('refId');
        
        if (statusParam === 'success') {
            setStatus('success');
            setMessage(`پرداخت شما با موفقیت انجام شد. شماره پیگیری: ${refId || '---'}`);
            
            // به‌روزرسانی اشتراک کاربر در دیتابیس
            const userData = localStorage.getItem('currentUser');
            if (userData) {
                const user = JSON.parse(userData);
                const tempPlan = localStorage.getItem('temp_plan');
                const tempDays = localStorage.getItem('temp_days');
                
                if (tempPlan && tempDays) {
                    axios.post(`${process.env.REACT_APP_API_URL}/api/payment/activate-subscription`, {
                        userId: user._id,
                        plan: tempPlan,
                        days: tempDays
                    })
                    .then(response => {
                        if (response.data.success) {
                            console.log('اشتراک با موفقیت فعال شد');
                            // به‌روزرسانی اطلاعات کاربر در localStorage
                            user.hasActiveSubscription = true;
                            user.subscriptionPlan = tempPlan;
                            user.subscriptionExpiry = response.data.expiryDate;
                            localStorage.setItem('currentUser', JSON.stringify(user));
                        }
                    })
                    .catch(err => console.error('خطا در فعال‌سازی اشتراک:', err));
                }
                
                localStorage.removeItem('temp_plan');
                localStorage.removeItem('temp_days');
            }
        } else if (statusParam === 'failed') {
            setStatus('failed');
            setMessage('پرداخت ناموفق بود. لطفاً مجدداً تلاش کنید.');
            localStorage.removeItem('temp_plan');
            localStorage.removeItem('temp_days');
        } else {
            setStatus('error');
            setMessage('خطایی در پرداخت رخ داده است.');
            localStorage.removeItem('temp_plan');
            localStorage.removeItem('temp_days');
        }
    }, [searchParams]);

    return (
        <>
            <Navbar />
            <div className="payment-result-container">
                <div className="payment-result-card">
                    {status === 'success' && (
                        <>
                            <div className="success-icon">✅</div>
                            <h2>پرداخت موفق</h2>
                            <p>{message}</p>
                            <Link to="/subscription" className="btn-back">بازگشت به صفحه اشتراک</Link>
                        </>
                    )}
                    {status === 'failed' && (
                        <>
                            <div className="error-icon">❌</div>
                            <h2>پرداخت ناموفق</h2>
                            <p>{message}</p>
                            <Link to="/subscription" className="btn-back">تلاش مجدد</Link>
                        </>
                    )}
                    {status === 'error' && (
                        <>
                            <div className="error-icon">⚠️</div>
                            <h2>خطا</h2>
                            <p>{message}</p>
                            <Link to="/subscription" className="btn-back">بازگشت به صفحه اشتراک</Link>
                        </>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PaymentResult;